<script setup lang="ts">
import { computed } from "vue";
import { ApolloError } from "@apollo/client/errors";

// ///////////////////
// Props
// ///////////////////

const props = defineProps<{
  error: ApolloError | null;
  name: string;
}>();

// Suppress known transient auth errors (e.g. when running locally against a
// non-matching env and the Hasura JWT signature can't be verified). They
// would otherwise spam every data provider on the page. Real GraphQL errors
// still surface normally.
const isSuppressed = (message: string) => message.includes("JWSInvalidSignature") || message.includes("Could not verify JWT");

const visible = computed(() => {
  if (!props.error) return false;
  return !isSuppressed(props.error.message ?? "");
});
</script>

<template>
  <div
    v-if="visible"
    class="rounded-4 t-small bg-app-red-600 dark:bg-app-red-fill flex flex-col items-center justify-center p-2 text-white">
    GraphQL{{ name }}Error
    <p class="mt-px-16 t-xs">
      {{ error?.message }}
    </p>
  </div>
</template>
